(function () {
  $(document).ready(function () {
    var body = $('body'),
      yo1 = $('div.yo1')
    yo2 = $('div.yo2')
    yo3 = $('div.yo3')
    yo4 = $('div.yo4')
    yo42 = $('div.yo42')
    yo5 = $('div.yo5')
    yo6 = $('div.yo6')
    yo7 = $('div.yo7')
    yo8 = $('div.yo8')
    yo9 = $('div.yo9')
    body.jKit()
			// parallaxContainer.css({'cursor' : 'none'});
    yo1.jKit('parallax', { 'strength': '1', 'axis': 'x'}).show()
    yo2.jKit('parallax', { 'strength': '0.5', 'axis': 'x'}).show()
    yo3.jKit('parallax', { 'strength': '1', 'axis': 'x'}).show()
    yo4.jKit('parallax', { 'strength': '0.4', 'axis': 'x'}).show()
    yo5.jKit('parallax', { 'strength': '0.5', 'axis': 'both'}).show()
    yo6.jKit('parallax', { 'strength': '0.05', 'axis': 'x'}).show()
    yo7.jKit('parallax', { 'strength': '0.5', 'axis': 'x'}).show()
    yo8.jKit('parallax', { 'strength': '0.5', 'axis': 'x'}).show()
    yo9.jKit('parallax', { 'strength': '0.3', 'axis': 'x'}).show()
    yo42.jKit('parallax', { 'strength': '1', 'axis': 'x'}).show()
  })
})()
